import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Tooltip, Space, Tag } from "antd";
import { FileDoneOutlined, UnorderedListOutlined, CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import http from "../../../services/http";

export const AvaliacoesResultados = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  useEffect(() => {
    listarResultadosAvaliacoes();
  }, []);

  // LISTAR
  const listarResultadosAvaliacoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/listar_resultados`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "avaliacao",
      title: "Avaliação",
    },
    {
      dataIndex: "ano",
      title: "Ano",
    },
    {
      dataIndex: "colaborador",
      title: "Colaborador",
    },
    {
      dataIndex: "status_pdi",
      title: "PDI",
      render: (_, e) => (e.status_pdi > 0 ? <Tag color="green">Gerado</Tag> : <Tag color="blue">Não gerado</Tag>),
      renderText: (e) => (e.status_pdi > 0 ? "Gerado" : "Não Gerado"),
    },
    {
      dataIndex: "realizados",
      width: 60,
      title: <CheckCircleOutlined style={{ fontSize: 16, color: "#60b565" }} />,
      sorter: false,
    },
    {
      dataIndex: "aguardando",
      width: 60,
      title: <ClockCircleOutlined style={{ fontSize: 16, color: "red" }} />,
      sorter: false,
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      sorter: false,
      width: 50,
      render: (_, e) => (
        <Space.Compact>
          <Tooltip title="Detalhes">
            <Button
              loading={loading}
              onClick={() => navigate(`/avaliacoes/resultados/detalhes/${e.id_colaborador}/${e.id_avaliacao}`)}
              icon={<UnorderedListOutlined />}
            />
          </Tooltip>
        </Space.Compact>
      ),
    },
  ];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Avaliações Resultados"
              subtitle="Resultados de avaliações realizadas"
              icon={<FileDoneOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Button type="link" onClick={() => navigate("/avaliacoes/resultados_descritivas")}>
                    Relatório Quest. Descritivas
                  </Button>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
